"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToException = exports.ApiException = void 0;
var ApiException = /** @class */ (function () {
    function ApiException(exception) {
        this.exception = exception;
    }
    return ApiException;
}());
exports.ApiException = ApiException;
function convertToException(exception, errorCodes) {
    if (!exception.message) {
        throw exception;
    }
    var apiException = errorCodes[exception.message];
    if (apiException) {
        throw new apiException(exception);
    }
    throw exception;
}
exports.convertToException = convertToException;
